import Footer from "../../Footer";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";
import QuickPackage from "./component/QuickPackage";
import FrequentCustomer from "./component/FrequentCustomer";
import TotalPackage from "./component/TotalPackage";
import { useEffect, useState } from "react";
import moment from "moment";
import api_requests from "../../resources/api_requests";
import QuickPackageContentLoader from "./component/QuickPackageContentLoader";
import FrequentCustomerContentLoader from "./component/FrequentCustomerContentLoader";
import TotalPackageContentLoader from "./component/TotalPackageContentLoader";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [order_stats, set_order_stats] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    console.log("././././././/././././.--", process.env);
    console.log(
      "././././././/././././.-- logging store url",
      process.env.API_STORE_URL,
    );
    get_orders_stats();
  }, []);

  const get_orders_stats = async () => {
    set_order_stats({});
    try {
      setLoading(true);
      const response = await api_requests.get_all_orders_overview_orders_stats({
        statusBreakdown: 1,
        created_at:
          moment().subtract("15", "days").format("YYYY-MM-DD") +
          "," +
          moment().format("YYYY-MM-DD"),
      });
      set_order_stats(response.data?.stats);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex flex-col bg-white relative overflow-auto"
      style={{ height: `calc(100vh - 105px - env(safe-area-inset-bottom))` }}
    >
      <div className="flex flex-col items-center w-full bg-white">
        <div className="flex gap-5 justify-between items-center items-start self-stretch px-7 pt-4 pb-28 w-full bg-primary">
          <img
            loading="lazy"
            src={ImageLinks.pidge_white_logo}
            alt=""
            className="object-contain shrink-0 w-14 aspect-[2.43]"
          />
          <img
            loading="lazy"
            src={ImageLinks.default_profile}
            alt=""
            className="object-contain shrink-0 aspect-square rounded-[30px] w-[31px]"
            onClick={() => navigate("/account")}
          />
        </div>
        <div
          className="flex flex-col gap-[20px] w-full max-w-[323px] absolute top-[63px] p-2 "
          // style={{ height: `calc(100vh - 155px)` }}
        >
          {isLoading ? <QuickPackageContentLoader /> : <QuickPackage />}
          {isLoading ? <FrequentCustomerContentLoader /> : <FrequentCustomer />}
          {isLoading ? (
            <TotalPackageContentLoader />
          ) : (
            <TotalPackage order_stats={order_stats} is_loading={isLoading} />
          )}
        </div>
        <Footer bottom={3.5} />
        <div
          className=" fixed bottom-[0px] flex flex-col px-6 pt-3.5 mt-5 pb-[13px] rounded-bl-none rounded-br-none w-full text-xs font-semibold leading-none text-center whitespace-nowrap bg-white rounded-3xl shadow-[0px_-2px_8px_rgba(73,40,151,0.1)] text-stone-900"
          style={{ paddingBottom: "calc(13px + env(safe-area-inset-bottom))" }}
        >
          <div className="flex gap-5 justify-between self-center w-full max-w-[274px]">
            <div
              className="flex flex-col"
              role="button"
              tabIndex={0}
              onClick={() => navigate("/order-track-list?tab=COMPLETED")}
            >
              <img
                loading="lazy"
                src={ImageLinks.eva_calendar_outline}
                alt=""
                className="object-contain self-center w-5 aspect-square"
              />
              <p>{t("completed")}</p>
            </div>
            <div
              className="flex flex-col"
              role="button"
              tabIndex={0}
              onClick={() => navigate("/wallet-list")}
            >
              <img
                loading="lazy"
                src={ImageLinks.bx_wallet}
                alt=""
                className="object-contain self-center w-5 aspect-square"
              />
              <p>{t("wallet")}</p>
            </div>
            <div
              className="flex flex-col"
              role="button"
              tabIndex={0}
              onClick={() => navigate("/saved-address")}
            >
              <img
                loading="lazy"
                src={ImageLinks.address_book}
                alt=""
                className="object-contain self-center w-5 aspect-square"
              />
              <p>{t("addresses")}</p>
            </div>
          </div>
          {/* <div className="flex shrink-0 mt-1 bg-white border border-solid border-violet-600 border-opacity-20 h-[7px] rounded-[30px]" /> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
